import { memo } from "react";

import AwardsWinnerBadge2024En from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2024En";
import AwardsWinnerBadge2024Fr from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2024Fr";
import AwardsWinnerBadge2025En from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2025En";
import AwardsWinnerBadge2025Fr from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2025Fr";
import AwardsWinnerBadge2026En from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2026En";
import AwardsWinnerBadge2026Fr from "@/icons/__generated__/AwardsWinnerBadge/AwardsWinnerBadge2026Fr";

interface AwardsWinnerBadgeIconProps {
  year: number;
  country: string;
}

/**
 * This is the Badge Icon for the It is used in the AwardsWinnerBadge component.
 * It is used as a trigger to show the tooltip/drawer for the AwardsWinnerBadge component.
 * This is shown on the listing page.
 */
const AwardsWinnerBadgeIcon = ({
  year,
  country,
}: AwardsWinnerBadgeIconProps) => {
  const badgeIconClassnames =
    "group-hover:[&>path:first-child]:tw-fill-gray-700";

  switch (year) {
    case 2024:
      switch (country) {
        case "FR":
          return <AwardsWinnerBadge2024Fr className={badgeIconClassnames} />;
        default:
          return <AwardsWinnerBadge2024En className={badgeIconClassnames} />;
      }
    case 2025:
      switch (country) {
        case "FR":
          return <AwardsWinnerBadge2025Fr className={badgeIconClassnames} />;
        default:
          return <AwardsWinnerBadge2025En className={badgeIconClassnames} />;
      }
    case 2026:
      switch (country) {
        case "FR":
          return <AwardsWinnerBadge2026Fr className={badgeIconClassnames} />;
        default:
          return <AwardsWinnerBadge2026En className={badgeIconClassnames} />;
      }
    default:
      return null;
  }
};

export default memo(AwardsWinnerBadgeIcon);
